<template>
    <div id="Consolenew_device" :class="IsShow?'':'hidden'">
        <div class="Consolenew-heade">
            <b>媒体列表</b>
            <span class="text-all">媒体数：<p>{{all}}</p> &nbsp;</span>
            <span class="text-Unbound">未绑定数：<p>{{Unbound}}</p> &nbsp;</span>
            <span class="text-online">在线数：<p>{{online}}</p> </span>
            <span class="text-unline">离线数：<p>{{unline}}</p> </span>
        </div>
        <div class="text-data">
            <el-table :header-cell-style="{background:'#02142a',color:'cornflowerblue',border:'1px solid #64dcff'}" element-loading-text="加载中" element-loading-background="rgba(0, 0, 0, 0.6)" :cell-style="{border:'1px solid #64dcff'}" :data="tableData" ref="Opentable" :row-class-name="tableRowClassName" @row-click="getDetails" @row-dblclick="rowdblclick" border highlight-current-row style="width: 100%" height=100% v-loading="loading">
                <el-table-column prop="lightBoxCode" label="媒体编号" width="130" sortable>
                </el-table-column>
                <el-table-column prop="deviceNickCode" label="设备编号" width="130" sortable>
                </el-table-column>
                <el-table-column prop="lightBoxName" label="媒体名称" width="140">
                </el-table-column>
                <el-table-column prop="lastPowerWaste" label="电流" width="140" sortable>
                </el-table-column>
                <el-table-column prop="lastLight" label="亮度" width="80" sortable>
                </el-table-column>
                <el-table-column prop="lastWorkedTime" label="工作时长" width="110" sortable>
                </el-table-column>
                <el-table-column prop="lastACStatus" label="AC通断电状态" width="140" sortable>
                    <template slot-scope="scope">
                        <span v-if="scope.row.lastACStatus==0">关断</span>
                        <span v-if="scope.row.lastACStatus==1">导通</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
export default {
    name: 'consolenew_device',
    props: {
        SiteId: {
            type: Number,
            default: 1
        },
        IsShow:{
            type: Boolean,
            default:false
        }
    },
    data: function() {
        return {
            searchform: {
                siteid: "",
            },
            Site_Id: 1,
            tableData: [],
            all: 0,
            Unbound: 0,
            online:0,
            unline:0,
            loading: true,
            currentRow: null
        }
    },
    watch: {
        SiteId: function(newSiteId, oldSiteId) {
            this.initData();
        }
    },
    methods: {
        tableRowClassName({ row, rowIndex }) {
            if (row.isOnline == 1) {
                return 'success-row';
            }
            if(row.isOnline==null){
                row.deviceNickCode='未绑定设备';
            }
            return 'null-row';
        },
        getDetails(row) {
            this.$store.commit("setADId", row.aDId);
            this.$emit("changeAd");
            //    console.log(row)
        },
        rowdblclick(row){
            this.$router.push({path:'/lightbox/infoforsite/'+this.SiteId+"/"+row.lightBoxCode});
        },
        initData() {
            var Vuethis = this;
            this.loading = true;
            //this.$hrraxios.get(this.$api.device.getdeviceList, {params:this.searchform})
            this.$hrraxios.get(this.$api.device.getdevicebysiteid + this.SiteId)
                .then(function(response) {
                    Vuethis.loading = false;
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.tableData = data.Data;
                        Vuethis.online = 0;
                        Vuethis.unline = 0;
                        Vuethis.Unbound = 0;
                        Vuethis.all=Vuethis.tableData.length;
                        for (let d = 0; d < Vuethis.tableData.length; d++) {
                            if (Vuethis.tableData[d].isOnline == 1) {
                                Vuethis.online += 1;
                            }
                            if (Vuethis.tableData[d].isOnline == 0) {
                                Vuethis.unline += 1;
                            }
                            if (Vuethis.tableData[d].isOnline == null) {
                                Vuethis.Unbound += 1;
                            }
                        }
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.loading = false;
                    console.log(error);
                });
        },
        initParamsData() {},
    },
    created() {
        this.initData();
        this.initParamsData();
    }
};
</script>
<style>
@media screen and (max-width: 1500px) {
    .Consolenew-heade {
        line-height: 250%!important;
    }
}
#Consolenew_device {
    position: relative;
    background: url("../../assets/device_bg.png");
    background-size: 100% 100%;
    width: 98.5%;
    height: 30%;
    margin-top: 15px;
}

#Consolenew_device .el-table__empty-block {
    background-color: #02142a;
}

#Consolenew_device .el-table--scrollable-x .el-table__body-wrapper {
    background-color: #02142a;
}
.text-data {
    position: absolute;
    width: 96%;
    height: 78%;
    overflow: hidden;
    margin-left: 2%;
    margin-top: 8%;
}

.text-data .el-table--border,
.el-table--group {
    border: 0px;
}

/* 用来设置当前页面element全局table 选中某行时的背景色*/
.text-data .el-table__body tr.current-row>td {
    background-color: rgb(32, 80, 120) !important;
    /* color: #f19944; */
    /* 设置文字颜色，可以选择不设置 */
}

/* 用来设置当前页面element全局table 鼠标移入某行时的背景色*/
.text-data .el-table--enable-row-hover .el-table__body tr:hover>td {
    background-color: #f5f5f500;
    /* color: #f19944; */
    /* 设置文字颜色，可以选择不设置 */
}

.Consolenew-heade {
    position: absolute;
    width: 100%;
    height: 9%;
    line-height: 300%;
}

.Consolenew-heade,
b,
p,
span {
    display: inline-block;
}

.Consolenew-heade b {
    position: absolute;
    font-size: 1.2vmax;
    margin-left: 2%;
    color: white;
}

.Consolenew-heade span {
    font-size: 1vmax;
    color: #64dcff;
    position: absolute;
    top:0px;
}
.text-all {
    margin-left: 24%;
}
.text-all p {
    color: #fff;
}
.text-Unbound {
    margin-left: 42%;
}
.text-Unbound p {
    color: #686868;
}
.text-online {
    margin-left: 62%;
}
.text-online p {
    color: #18d632;
}
.text-unline {
    margin-left: 80%;
}
.text-unline p {
    color: #686868;
}
.text-data .el-table {
    border-bottom: 2px solid #64dcff;
}

.text-data .el-table .success-row {
    background: #02142a;
    color: #18d632;
}

.text-data .el-table .null-row {
    background: #02142a;
    color: #686868;
}

.text-data .el-table__body-wrapper::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 8px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 8px;
}

.text-data .el-table__body-wrapper::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 16px;
    box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.5);
}

.text-data .el-table__body-wrapper::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.2);
    border-radius: 16px;
    background-color: rgba(255, 255, 255, 0.5);
}
</style>